<template>
    <div>
        <el-form  ref="ruleForm" :model="procedureList" label-width="110px" size="mini">
            <el-form-item prop="procedureName" class="lable-width" label="流程名">
                <el-input class="input-width" placeholder="请输入流程名" clearable v-model="procedureList.procedureName"></el-input>
            </el-form-item>
            <el-form-item prop="type" class="lable-width" label="类型">
                <el-select clearable class="input-width"  v-model="procedureList.type" filterable placeholder="请选择">
                    <el-option
                            v-for="item in type"
                            :key="item.id"
                            :label="item.v"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="order" class="lable-width" label="次序">
                <el-input class="input-width" placeholder="请输入次序" clearable v-model="procedureList.order"></el-input>
            </el-form-item>
            <el-form-item prop="state" class="lable-width" label="状态">
                <el-select clearable class="input-width"  v-model="procedureList.state" filterable placeholder="请选择">
                    <el-option
                            v-for="item in stateList"
                            :key="item.id"
                            :label="item.v"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="createPreson1" class="lable-width" label="录入人">
                <el-input class="input-width" placeholder="请输入录入人姓名" clearable v-model="procedureList.createPreson1"></el-input>
            </el-form-item>
            <el-form-item prop="createTime1" class="lable-width" label="录入时间">
                <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        class="input-width"
                        v-model="procedureList.createTime1"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    //import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'reviseTemplate',
        props:{
            procedureList:{
              type:Object
            },
            editData:{
                type:Object
            },
            addData:{
                type:Object
            }
        },
        data(){
            return{



                stateList:[{
                    id:1,
                    v:'运行中'
                },{
                    id:2,
                    v:'调整中'
                },{
                    id:3,
                    v:'停机'
                },],
                type:[{
                    id:1,
                    v:'温度'
                },{
                    id:2,
                    v:'压力'
                },{
                    id:3,
                    v:'液位'
                },{
                    id:4,
                    v:'瞬时流量'
                },{
                    id:5,
                    v:'累计流量'
                },{
                    id:6,
                    v:'耗电量'
                },{
                    id:7,
                    v:'用汽量'
                }],
                value:'',
                weekdate:'',
                // gwdata:[],
                // stationdata:[],
                monthdate:'',
                positionopen:0,
                nfcopen:0,

            }
        },
        watch:{
        },
        mounted(){
            // if(this.editData.id!==0){
            //   this.dcsdetail()
            // }
        },
        methods:{

            gwchange(val){
                this.editData.station=val
                // console.log(val)
            },
            bzchange(val){
                this.editData.bid=val
                // if(this.editData.cjName!=='') {
                //
                //     this.getTeamsList()
                // }
            },
            nfcfocus(){
                this.nfcopen=1
            },
            positionfocus(){
                this.positionopen=1

            },
            nfcblur(){
                this.nfcopen=0
            },
            positionblur(){
                this.positionopen=0
            },
            timepick(val){
                if(val==null){
                    this.editData.beginTime=''
                }
            },
            cycleselect(val){
                this.editData.cycle=val

                // if(val==''){
                this.editData.beginTime=''
                // }
                this.monthdate=''
                this.weekdate=''
                // console.log(this.datatimes)
            },
            radiojudge(val){

            },
            localradio(val){
                // console.log(val)
                this.editData.nfc=val
                // this.tishi=1
            },
            ...mapActions(["getCurrentMenuId"]),

            //部门


            //岗位


            //模板

            //业务配置保存
            async save() {
                // console.log(this.editData.type)
                // return
                if(!this.editData.type){
                    this.editData.type=0
                }
                if(parseFloat(this.editData.upperBound)!==''&&parseFloat(this.editData.lowerBound)!==''){
                    if(parseFloat(this.editData.upperBound) <= parseFloat(this.editData.lowerBound)){
                        this.$message({
                            message: '下限大于上限，请重新输入',
                            type: 'error'
                        });
                        return
                    }
                }

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    no:this.editData.no,
                    name:this.editData.name,
                    inputTitle:this.editData.inputTitle,
                    inputType:this.editData.inputType,
                    inputUnit:this.editData.inputUnit,
                    upperBound:this.editData.upperBound,
                    lowerBound:this.editData.lowerBound,
                    inputWidth:this.editData.inputWidth,
                    dcsWidth:this.editData.dcsWidth,
                    pid:this.editData.pid,
                    orderNo:this.editData.orderNo,
                    type:this.editData.type
                }
                for(let i in params){
                    if(params[i]===''){
                        delete params[i]
                    }
                }
                // console.log(params)
                // return
                let res = await API.save(params);
                if (res.code == 1) {
                    this.$emit('list')
                    this.$emit('close')
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });

                } else if (res.code == -2) {

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else if (res.code == -1){
                    this.editData.beginTime=''
                    this.$message({
                        message:res.message,
                        type:'warning'
                    })
                }else {
                    this.editData.beginTime=''
                    this.$message.error(res.message);

                }
            },
            close(){
                this.$emit('close')
            },

            onSubmit(){
                this.$emit('procedureList',this.procedureList)
//获取对应ID
//                 this.$refs.ruleForm.validate((valid) => {
//                     if (valid) {
//                         // console.log(this.editData.xfname)
//
//                         // let add1=this.consumername.filter(item=>{
//                         //     return  item.name==this.editData.consumerName
//                         // })
//                         // console.log(add1)
//                         // this.editData.consumerId=add1[0].id
//                         this.save()
//                     } else {
//                         // console.log('error submit!!');
//                         return false;
//                     }
//                 });


            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>